import { useQuery } from 'react-query';
import { useAuthorizedClient } from '../../contexts/Auth';
import { Merchant } from './types';
import { useMerchantId } from '../useMerchantId';

function useMerchant() {
  const merchantId = useMerchantId();
  const client = useAuthorizedClient();

  return useQuery(
    ['merchant'],
    () =>
      client(`/v1/merchants/${merchantId}`, {}).then((data: Merchant) => {
        const merchantFullName = data?.company_name
          ? data.company_name
          : data?.first_name && data?.last_name
          ? `${data.first_name} ${data.last_name}`
          : '';

        return {
          ...data,
          full_name: merchantFullName,
        };
      }),
    {
      enabled: !!merchantId,
    }
  );
}

export { useMerchant };
